import React from 'react';

type CopyToClipboardProps = {
  text: string;
  onCopy: (e: any) => void;
  children: React.ReactNode;
};
const CopyToClipboard = (props: CopyToClipboardProps) => {
  const { text, onCopy, children } = props;
  const onClick = async (e: any) => {
    e.stopPropagation();
    await navigator.clipboard.writeText(text);
    onCopy(e);
  };
  return <div onClick={onClick}>{children}</div>;
};

export default CopyToClipboard;
